import { UATConstants } from 'src/Common/Models/UATConstants';
import { ITenantUIConfig, TenantProvider } from 'src/tenantConfig/interface/index.ts';
import { GPSFilterConfig } from './filters/GPSFilterConfig';
import { TrueFalse } from 'src/Common/manageViews/interfaces/DropdownData';
export const GPSTenantConfig: Partial<ITenantUIConfig> = {
  nodeName: [UATConstants.PlaceholdersAndTitles.GPS], //Partner Investments
  provider: TenantProvider.ARTEMIS,
  TenantExperience: true,
  FeatureConfig: {
    SensitiveInfoValidation: false,
    SensativeInfoErrorCount: false,
    FieldConfig: GPSFilterConfig,
    AttachmentConfigurations: [],
    Navigation: {
      GlobalSearch: true,
      Copilot: true,
      Analytics: false,
      RequestAccess: true,
      Settings: true,
      Notifications: true,
      Help: true,
    },
    Hub: {
      Filter: true,
      FilterConfig: GPSFilterConfig,
      AreaPath: [UATConstants.GPSInvestmentsAreaPath],
      Title: UATConstants.TenantTitles.GPS,
      ADOTitle: UATConstants.TenantADOText.GPS,
      Create: [
        {
          Text: UATConstants.CreateActionMenuTitle.CreateGPSRequest,
          Key: UATConstants.CreateActionMenuKey.CreateGPSRequest,
          NodeName: '',
        },
      ],
      Download: true,
      Email: true,
      LocalSearch: true,
      ColumnOptions: true,
      ColumnOptionsConfig: [],
      SplitMode: true,
      BulkEdit: false,
      BulkEditConfig: [],
      BulkUpload: true,
      DownloadTemplate: true,
      CreateRAID: false,
      DownloadTemplateConfig: {
        tenantToolName: 'gps',
        title: UATConstants.TenantTitles.GPS,
        excelColumnSequence: {
          'Investment Title': 1,
          'Business Type': 2,
          'Requester': 3,
          'Request Type': 4,
          'Ask Type': 5,
          'Request Reason': 6,
          'Area(s)': 7,
          'Investment Description': 8,
          'Financial Economics': 9,
          'Investment Start Date': 10,
          'Investment End Date': 11,
          'MCEM Stage': 12,
          'Investment Amount (USD)': 13,
          'Expected Incremental Revenue': 14,
          'ACO': 15,
          'CELA Stakeholder': 16,
          'Change Request Type': 17,
          'Co-op': 18,
          'Compliance Stakeholder': 19,
          'Corp Accounting Stakeholder': 20,
          'Customer Segment': 21,
          'ECIF': 22,
          'Engagement Type': 23,
          'Finance Next Steps, Exceptions, Notes': 24,
          'Finance Stakeholder': 25,
          'Funding Source': 26,
          'Funding Type': 27,
          'GL/PC Code': 28,
          'If this deal belongs to a framework, provide the Case ID': 29,
          'Investment Type': 30,
          'Is there a financial impact?': 31,
          'Is this a significant design changes (change to POR) and/or require incremental funding?': 32,
          'Launch Manager': 33,
          'Operations Stakeholder': 34,
          'Opex': 35,
          'Opportunity ID': 36,
          'Other': 37,
          'Partner Name': 38,
          'Partner one ID': 39,
          'Partner Type': 40,
          'Payout Type': 41,
          'Provide the Case ID of the investment in market': 42,
          'RevAdjust': 43,
          'Skilling': 44,
          'Solution Area': 45,
          'Sponsorship': 46,
          'Strategy Lead': 47,
          'Is the Partner an LSP, CSP, Disti or current ECIF supplier?': 48,
          'Is there a new type of customer/partner financial data being collected, or is existing customer/partner financial data being used in a manner that has not been previously implemented?': 49,
          'Does this investment involve a Government/ State-Owned partner* OR is the partner located in a high-risk country**?': 50,
          'Corp Accounting Next Steps, Exceptions, Notes': 51,
          'Compliance Next Steps, Exceptions, Notes': 52,
          'Operations Next Steps, Exceptions, Notes': 53,
          'Final Payment Milestone': 54,
        },
      },
      RelatedItem: true,
    },
    ManageAction: {
      NewExperience: true,
      MandateFormPickers: [
        { formFieldName: 'gps_assignedto', formFieldLabel : UATConstants.PlaceholdersAndTitles.ActionOwner,apiFieldName: 'assignedto' },
        { formFieldName: 'gps_requestorsinfo', formFieldLabel : UATConstants.PlaceholdersAndTitles.Requestor, apiFieldName: 'requestorsinfo' },
        { formFieldName: 'gps_pirmanager', formFieldLabel : UATConstants.PlaceholdersAndTitles.GPSPIRManager, apiFieldName: 'gps_pirmanager' },
        { formFieldName: 'gps_StrategyLead', formFieldLabel : UATConstants.PlaceholdersAndTitles.GPSStrategyLead, apiFieldName: 'gps_strategylead' },
        { formFieldName: 'gps_LaunchManagerName', formFieldLabel : UATConstants.PlaceholdersAndTitles.GPSLaunchManager, apiFieldName: 'gps_launchmanagername' },
        { formFieldName: 'gps_FinancePIRStakeholder', formFieldLabel : UATConstants.PlaceholdersAndTitles.GPSFinanceStakeholder, apiFieldName: 'gps_financepirstakeholder' },
        { formFieldName: 'gps_CorpAccountingPIRStakeholder', formFieldLabel : UATConstants.PlaceholdersAndTitles.GPSCorpAccountingStakeholder, apiFieldName: 'gps_corpaccountingpirstakeholder' },
        { formFieldName: 'gps_CELAPIRStakeholderName', formFieldLabel : UATConstants.PlaceholdersAndTitles.GPSCELAStakeholder, apiFieldName: 'gps_celapirstakeholdername' },
        { formFieldName: 'gps_CompliancePIRStakeholder', formFieldLabel : UATConstants.PlaceholdersAndTitles.GPSComplianceStakeholder, apiFieldName: 'gps_compliancepirstakeholder' },
        { formFieldName: 'gps_OperationsPIRStakeholderName', formFieldLabel : UATConstants.PlaceholdersAndTitles.GPSOperationsStakeholder, apiFieldName: 'gps_operationspirstakeholdername' },

      ], //Not in dynamic form
      Header: {
        Tags: true,
        Actions: {
          Follow: true,
          Email: true,
          CopyLink: true,
        },
      },
      Tabs: {
        TechnicalFeedback: false,
        RelatedItems: {
          showRelatedTab: true,
          showTFTCreated: false,
        },
        Attachments: true,
        History: true,
      },
      Panes: {
        CopilotInsights: {
          CustomerInsights: true,
          DiscussionInsights: true,
        },
        StatusUpdate: true,
        ClosureStatement: true,
        Discussion: true,
        Tasks: true,
        EmailConversation: false,
      },
    },
    ManageView: {
      isArtemisIntegrationEnabled: true,
      showAddViewButton: true,
      showAddFolderButton: true,
      showCommandBar: true,
      showPreviewFeatureMessageBar: false,
      showSelectFields: false,
      systemViewsFolderId: 'f0a0d19d-8147-432c-b0f2-25e655dd7b71',
      sharedViewsFolderId: 'de59a3cd-bc73-445a-857d-828a0a733425',
    },
  },
};

// Generated by GitHub Copilot | Updated on: 2026-06-04 | 35 lines modified | Added Compliance/Corp Accounting/Operations Next Steps, Exceptions, Notes to DownloadTemplateConfig
// Generated by GitHub Copilot | Updated on: 2026-09-01 | 1 line added | Sequenced Final Payment Milestone export